module.exports = __webpack_public_path__ + "static/media/liderazgo-AUTOAGENCIA(B).54003c0d.svg";